import { render, staticRenderFns } from "./WatermarkOverlay.vue?vue&type=template&id=d00cb1ca&scoped=true"
import script from "./WatermarkOverlay.vue?vue&type=script&lang=js"
export * from "./WatermarkOverlay.vue?vue&type=script&lang=js"
import style0 from "./WatermarkOverlay.vue?vue&type=style&index=0&id=d00cb1ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00cb1ca",
  null
  
)

export default component.exports